import { combineSlices } from "@reduxjs/toolkit";
import loginReducer from "./login/loginSlice";
import pharmacyDocumentsReducer from "./uploadedPharmacyDocuments/uploadedPharSlice";
import PharmacyMediaReducer from "./uploadPharmacyMedia/uploadPharmacyMediaSlice";
import registerPatientReducer from "./patientRegister/patientRegisterSlice";
import fetchDocumentsReducer from "./getDocument/fetchDocumentSlice";
import doctorClinicScheduleReducer from "./clinicSchedule/doctorClinicScheduleSlice";
import doctorEmergencyScheduleReducer from "./emergencySchedule/updateEmergencyScheduleSlice";
import doctorPersonalInfoReducer from "./doctorPersonal/doctorPersonalInfoSlice";
import doctorPatientCountReducer from "./patientCount/doctorPatientCountSlice";
import doctorProfileReducer from "./doctorProfile/doctorProfileSlice";
import consultationReducer from "./consultation/consultationSlice";
import doctorDocumentsReducer from "./uploadedDoctorDocuments/uploadedDocSlice";
import doctorAppointmentsReducer from "./appointments/doctorAppointmentsSlice";
import updateDoctorDocumentsReducer from "./updateUploadedDoctorDocuments/updateDoctorDocumentSlice";
import fetchDoctorAppointmentsReducer from "./appointments/doctorAppointmentsSlice";
import verifyOtpReducer from "./verifyOtp/verifyOtpSlice";
import resendOtpReducer from "./sendOtp/resendOtpSlice";
import doctorConsultationPricingReducer from "./doctor-consultation-pricing/doctorConsultationPricingSlice";
import doctorWalletReducer from "./doctorWallet/doctorWalletSlice";
import doctorWalletTransactionsReducer from "./doctorWalletTransaction/doctorWalletTransactionsSlice";
import doctorWalletUnifiedTransactionsReducer from "./doctorWalletUnifiedTransactions/doctorWalletUnifiedTransactionsSlice";
import doctorWalletWithdrawalsReducer from "./withdrawals/doctorWalletWithdrawalsSlice";
import pharmacyWalletReducer from "./pharmacyWallet/pharmacyWalletSlice";
import pharmacyTransactionHistoryReducer from "./pharmacyTransactionHistory/pharmacyTransactionHistorySlice";
import insuranceLoginReducer from "./insuranceLogin/insuranceLoginSlice";
import medicalOrdersReducer from "./insuranceMedicalOrders/insuranceMedicalOrdersSlice";
import doctorConsultationClaimsReducer from "./insuranceDoctorConsultation/insuranceDoctorConsultationSlice";
import labTestsClaimsReducer from "./insuranceLabTests/insuranceLabTestsSlice";
import claimsStatisticsReducer from "./insuranceStatistics/insuranceStatisticsSlice";
import claimsHistoryReducer from "./claimsHistory/claimsHistorySlice";
import claimByIdReducer from "./claims/claimsSlice";
import verifyClaimReducer from "./claimVerify/verifyClaimSlice";
import rejectClaimReducer from "./claimsReject/claimsRejectSlice";
import approveClaimItemReducer from "./claimsApproveItem/claimsApproveItemSlice";
import rejectClaimItemReducer from "./claimsRejectItem/claimsRejectItemSlice";
import calculateClaimReducer from "./claimsCalculate/claimsCalculateSlice";
import updateClaimInvoiceReducer from "./claimsinvoice/claimsinvoiceSlice";
import exportClaimsReducer from "./claimsexport/claimsexportSlice";
import getClaimDocumentsReducer from "./claimsDocuments/claimsDocumentsSlice";
import updateHomeVisitScheduleReducer from "./homeVisitSchedule/updateHomeVisitScheduleSlice";
import updateHomeVisitOnlineReducer from "./homeVisitOnline/updateHomeVisitOnlineSlice";
import updateEmergencyOnlineReducer from "./emergencyOnline/updateEmergencyOnlineSlice";
import updateEmergencyHomeVisitOnlineReducer from "./emergencyHomeVisitOnline/updateEmergencyHomeVisitOnlineSlice";
import pharmacyOrdersReducer from "./pharmacyOrders/pharmacyOrdersSlice";
import confirmPharmacyOrderReducer from "./confirmPharmacyOrder/confirmPharmacyOrderSlice";
import rejectPharmacyOrderReducer from "./rejectPharmacyOrder/rejectPharmacyOrderSlice";
import approvePharmacyOrderReducer from "./approvePharmacyOrder/approvePharmacyOrderSlice";
import searchPharmacyMedicinesReducer from "./searchPharmacyMedicines/searchPharmacyMedicinesSlice";
import uploadDoctorAvatarReducer from "./uploadDoctorAvatar/uploadDoctorAvatarSlice";
import uploadPrescriptionReducer from "./uploadPrescription/uploadPrescriptionSlice";
import savePrescriptionReducer from "./savePrescription/savePrescriptionSlice";
import getPrescriptionByAppointmentReducer from "./getPrescriptionByAppointment/getPrescriptionByAppointmentSlice";
import uploadDoctorStampSignatureReducer from "./uploadDoctorStampSignature/uploadDoctorStampSignatureSlice";
import getPatientDetailsReducer from "./getPatientDetails/getPatientDetailsSlice";
import getPharmacyCategoriesReducer from "./getPharmacyCategories/getPharmacyCategoriesSlice";
import searchPharmacyMedicinesForDoctorReducer from "./searchPharmacyMedicinesForDoctor/searchPharmacyMedicinesForDoctorSlice";
import searchLabTestsReducer from "./searchLabTests/searchLabTestsSlice";
import searchImagingTestsReducer from "./searchImagingTests/searchImagingTestsSlice";
import searchPhysioServicesReducer from "./searchPhysioServices/searchPhysioServicesSlice";
import searchNurseServicesReducer from "./searchNurseServices/searchNurseServicesSlice";
import additionalIncomeReducer from "./additionalIncome/additionalIncomeSlice";
import searchPharmacyMedicinesAndCosmeticsReducer from "./searchPharmacyMedicinesAndCosmetics/searchPharmacyMedicinesAndCosmeticsSlice";
import getPharmacyProductsReducer from "./getPharmacyProducts/getPharmacyProductsSlice";
import doctorHomeVisitRequestsReducer from "./getDoctorHomeVisit/doctorHomeVisitRequestsSlice";
import doctorHomeVisitRequestsRecentReducer from "./getDoctorHomeVisitRecent/doctorHomeVisitRequestsRecentSlice";
import updateOnsiteScheduleReducer from "./updateOnsiteSchedule/updateOnsiteScheduleSlice";
import updateOnlineDecisionReducer from "./updateOnlineDecision/updateOnlineDecisionSlice";
import doctorAppointmentsPatientsReducer from "./doctorAppointmentsPatients/doctorAppointmentsPatientsSlice";
import requestAppointmentRescheduleReducer from "./requestAppointmentReschedule/requestAppointmentRescheduleSlice";
import createFollowupAppointmentReducer from "./createFollowupAppointment/createFollowupAppointmentSlice";
import notificationsReducer from "./notifications/notificationsSlice";
import pharmacyNotificationsReducer from "./pharmacy/notifications/pharmacyNotificationsSlice";
import pharmacyDashboardMetricsReducer from "./pharmacyDashboardMetrics/pharmacyDashboardMetricsSlice";
import pharmacySalesSummaryReducer from "./pharmacySalesSummary/pharmacySalesSummarySlice";
import pharmacyPopularProductsReducer from "./pharmacyPopularProducts/pharmacyPopularProductsSlice";
import doctorDashboardMetricsReducer from "./doctorDashboardMetrics/doctorDashboardMetricsSlice";
import pharmacyFinancialMetricsReducer from "./pharmacyFinancialMetrics/pharmacyFinancialMetricsSlice";
import getAppointmentByIdReducer from "./getAppointmentById/getAppointmentByIdSlice";
import updateOrderItemPriceReducer from "./updateOrderItemPrice/updateOrderItemPriceSlice";
import pharmacyChatOrdersReducer from "./pharmacyChatOrders/pharmacyChatOrdersSlice";
import payoutAccountReducer from "./payoutAccount/payoutAccountSlice";

export default combineSlices({
  login: loginReducer,
  pharmacyDocuments: pharmacyDocumentsReducer,
  PharmacyMedia: PharmacyMediaReducer,
  patientRegister: registerPatientReducer,
  getDocuments: fetchDocumentsReducer,
  doctorClinicSchedule: doctorClinicScheduleReducer,
  doctorEmergencySchedule: doctorEmergencyScheduleReducer,
  doctorProfile: doctorProfileReducer,
  doctorPersonalInfo: doctorPersonalInfoReducer,
  doctorDocuments: doctorDocumentsReducer,
  doctorPatientCount: doctorPatientCountReducer,
  consultation: consultationReducer,
  appointments: doctorAppointmentsReducer,
  updateDoctorDocuments: updateDoctorDocumentsReducer,
  fetchDoctorAppointments: fetchDoctorAppointmentsReducer,
  verifyOtp: verifyOtpReducer,
  resendOtp: resendOtpReducer,
  doctorConsultationPricing: doctorConsultationPricingReducer,
  doctorWallet: doctorWalletReducer,
  doctorWalletTransactions: doctorWalletTransactionsReducer,
  doctorWalletUnifiedTransactions: doctorWalletUnifiedTransactionsReducer,
  doctorWalletWithdrawals: doctorWalletWithdrawalsReducer,
  pharmacyWallet: pharmacyWalletReducer,
  pharmacyTransactionHistory: pharmacyTransactionHistoryReducer,
  insuranceLogin: insuranceLoginReducer,
  medicalOrders: medicalOrdersReducer,
  doctorConsultationClaims: doctorConsultationClaimsReducer,
  labTestsClaims: labTestsClaimsReducer,
  claimsStatistics: claimsStatisticsReducer,
  claimsHistory: claimsHistoryReducer,
  claimById: claimByIdReducer,
  verifyClaim: verifyClaimReducer,
  rejectClaim: rejectClaimReducer,
  approveClaimItem: approveClaimItemReducer,
  rejectClaimItem: rejectClaimItemReducer,
  calculateClaim: calculateClaimReducer,
  updateClaimInvoice: updateClaimInvoiceReducer,
  exportClaims: exportClaimsReducer,
  claimDocuments: getClaimDocumentsReducer,
  updateHomeVisitSchedule: updateHomeVisitScheduleReducer,
  updateHomeVisitOnline: updateHomeVisitOnlineReducer,
  updateEmergencyOnline: updateEmergencyOnlineReducer,
  updateEmergencyHomeVisitOnline: updateEmergencyHomeVisitOnlineReducer,
  pharmacyOrders: pharmacyOrdersReducer, //todo
  confirmPharmacyOrder: confirmPharmacyOrderReducer, //todo
  rejectPharmacyOrder: rejectPharmacyOrderReducer,
  approvePharmacyOrder: approvePharmacyOrderReducer,
  searchPharmacyMedicines: searchPharmacyMedicinesReducer, //todo
  doctorHomeVisitRequests: doctorHomeVisitRequestsReducer,
  uploadDoctorAvatar: uploadDoctorAvatarReducer,
  uploadPrescription: uploadPrescriptionReducer,
  uploadDoctorStampSignature: uploadDoctorStampSignatureReducer,
  savePrescription: savePrescriptionReducer,
  getPatientDetails: getPatientDetailsReducer,
  getPrescriptionByAppointment: getPrescriptionByAppointmentReducer,
  getPharmacyCategories: getPharmacyCategoriesReducer,
  searchPharmacyMedicinesForDoctor: searchPharmacyMedicinesForDoctorReducer,
  searchLabTests: searchLabTestsReducer,
  searchImagingTests: searchImagingTestsReducer,
  searchPhysioServices: searchPhysioServicesReducer,
  searchNurseServices: searchNurseServicesReducer,
  additionalIncome: additionalIncomeReducer,
  searchPharmacyMedicinesAndCosmetics:
    searchPharmacyMedicinesAndCosmeticsReducer,
  getPharmacyProducts: getPharmacyProductsReducer,
  doctorHomeVisitRequestsRecent: doctorHomeVisitRequestsRecentReducer,
  updateOnsiteSchedule: updateOnsiteScheduleReducer,
  updateOnlineDecision: updateOnlineDecisionReducer,
  doctorAppointmentsPatients: doctorAppointmentsPatientsReducer,
  requestAppointmentReschedule: requestAppointmentRescheduleReducer,
  createFollowupAppointment: createFollowupAppointmentReducer,
  notifications: notificationsReducer,
  pharmacyNotifications: pharmacyNotificationsReducer,
  pharmacyDashboardMetrics: pharmacyDashboardMetricsReducer,
  pharmacySalesSummary: pharmacySalesSummaryReducer,
  pharmacyPopularProducts: pharmacyPopularProductsReducer,
  doctorDashboardMetrics: doctorDashboardMetricsReducer,
  pharmacyFinancialMetrics: pharmacyFinancialMetricsReducer,
  getAppointmentById: getAppointmentByIdReducer,
  updateOrderItemPrice: updateOrderItemPriceReducer,
  pharmacyChatOrders: pharmacyChatOrdersReducer,
  payoutAccount: payoutAccountReducer,
});
